import React, { useLayoutEffect, useRef } from 'react';

export default function WordLabel({ word }) {
  const labelRef = useRef(null);

  useLayoutEffect(() => {
    const label = labelRef.current;
    const tile = label.parentElement;

    const fitLabel = () => {
      const tileStyle = window.getComputedStyle(tile);
      const availableWidth = label.getBoundingClientRect().width;
      if (availableWidth <= 1) return;

      // Start at the current desktop/mobile size, including after a word changes.
      const fontSize = parseFloat(tileStyle.fontSize);
      label.style.fontSize = `${fontSize}px`;
      const textRange = document.createRange();
      textRange.selectNodeContents(label);
      const textWidth = textRange.getBoundingClientRect().width;

      if (textWidth > availableWidth) {
        // Reserve a pixel for browser rounding; keep the complete label on one line.
        label.style.fontSize = `${fontSize * (availableWidth - 1) / textWidth}px`;
      }
    };

    fitLabel();
    const observer = typeof ResizeObserver !== 'undefined'
      ? new ResizeObserver(fitLabel) : null;
    observer?.observe(tile);
    window.addEventListener('resize', fitLabel);

    return () => {
      observer?.disconnect();
      window.removeEventListener('resize', fitLabel);
    };
  }, [word]);

  return <span className="game-item-label" ref={labelRef}>{word || ' '}</span>;
}
